import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert, AlertTitle, Button } from '@mui/material';
import { onMessage } from 'firebase/messaging';
import { messaging } from '../../firebaseConfig';

interface NotificationData {
    title: string;
    body: string;
    announcementId?: string;
}

const NotificationHandler: React.FC = () => {
    const navigate = useNavigate();
    const [notification, setNotification] = useState<NotificationData | null>(null);

    useEffect(() => {
        if (!messaging) return;
        const unsubscribe = onMessage(messaging, (payload) => {
            const title = payload.notification?.title ?? 'Новое уведомление';
            const body = payload.notification?.body ?? '';
            const announcementId = payload.data?.announcementId;
            setNotification({ title, body, announcementId });
            window.dispatchEvent(new Event('fcm-message'));
        });
        return unsubscribe;
    }, []);

    const handleClose = () => setNotification(null);

    const handleOpen = () => {
        if (notification?.announcementId) {
            navigate(`/announcements/${notification.announcementId}`);
        }
        setNotification(null);
    };

    return (
        <Snackbar
            open={!!notification}
            autoHideDuration={8000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert
                severity="info"
                onClose={handleClose}
                action={
                    notification?.announcementId ? (
                        <Button color="inherit" size="small" onClick={handleOpen}>
                            Открыть
                        </Button>
                    ) : undefined
                }
                sx={{ width: '100%' }}
            >
                <AlertTitle>{notification?.title}</AlertTitle>
                {notification?.body}
            </Alert>
        </Snackbar>
    );
};

export default NotificationHandler;
